import React from 'react'
import css from 'styled-jsx/css'
import styles from '~/styles/atoms/tag/tag.module.scss'

import { SpaceColor } from '~/common/define/color'
import { addClass } from '~/common/utils/html'
import InternalLink from '~/components/atoms/link/InternalLink'

export enum TagSize {
  SMALL,
  LARGE,
  SIMPLE,
}

export interface TagProps {
  text: string
  color?: SpaceColor
  size?: TagSize
  onClick?(e: React.MouseEvent<HTMLElement>): void
  link?: string
}

const Tag = ({text, color, size = TagSize.SMALL, onClick, link}: TagProps) => {
  const {className, styles: colorStyles} = size == TagSize.SMALL ? css.resolve`
    span, button, a {
      color: ${color};
    }
  ` : size == TagSize.LARGE ? css.resolve`
    span, button, a {
      background-color: ${color};
    }
  ` : css.resolve``

  const tagClass = className + addClass(styles.tag)
    + addClass(styles.large, size == TagSize.LARGE)
    + addClass(styles.small, size == TagSize.SMALL)
    + addClass(styles.simple, size == TagSize.SIMPLE)

  return (
    <>
      {onClick ?
        <button className={tagClass + addClass(styles.clickable)} onClick={onClick}>{text}</button> :
        link ?
          <InternalLink link={link} className={tagClass + addClass(styles.clickable)}>{text}</InternalLink> :
          <span className={tagClass}>
            {text}
          </span>
      }
      {colorStyles}
    </>
  )
}

export default Tag